import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { $getSelection, $isRangeSelection } from "lexical";
import { TOGGLE_LINK_COMMAND } from "@lexical/link";
import { useValidationService } from "../../../../../services/hooks/index.js";
import { Dialog, DialogContent } from "../../../../../Dialog/index.js";
import { Button } from "../../../../../Button/index.js";
import { TextInput } from "../../../../index.js";
import { sanitizeUrl } from "../../../utils/index.js";
import { useForm } from "../../hooks/index.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(void 0);
        });
    };
}
const LinkDialog = (t0)=>{
    const $ = c(63);
    const { editor, open, onClose, selectionText, selectionUrl } = t0;
    const [text, setText] = useState(selectionText || "");
    const [link, setLink] = useState(selectionUrl || "");
    const changed = text !== selectionText || link !== selectionUrl;
    const validator = useValidationService();
    let t1;
    if ($[0] !== link || $[1] !== text) {
        t1 = {
            text,
            link
        };
        $[0] = link;
        $[1] = text;
        $[2] = t1;
    } else t1 = $[2];
    const allValues = t1;
    let t2;
    if ($[3] !== validator) {
        t2 = validator.required("\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435");
        $[3] = validator;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t2) {
        t3 = [
            t2
        ];
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== selectionUrl || $[8] !== validator) {
        t4 = selectionUrl ? [] : [
            validator.required("\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435"),
            validator.validUrl("\u0417\u043D\u0430\u0447\u0435\u043D\u0438\u0435 \u043F\u043E\u043B\u044F \u0434\u043E\u043B\u0436\u043D\u043E \u0431\u044B\u0442\u044C \u0441\u0441\u044B\u043B\u043A\u043E\u0439")
        ];
        $[7] = selectionUrl;
        $[8] = validator;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== t3 || $[11] !== t4) {
        t5 = {
            text: t3,
            link: t4
        };
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    const fieldValidators = t5;
    const { errors, touched, validateField, hasValidationErrors, showError, handleBlur } = useForm(allValues, fieldValidators);
    let t6;
    if ($[13] !== showError || $[14] !== validateField) {
        t6 = (value)=>_async_to_generator(function*() {
                setText(()=>value || "");
                yield validateField("text", value);
                showError("text");
            })();
        $[13] = showError;
        $[14] = validateField;
        $[15] = t6;
    } else t6 = $[15];
    const handleChangeTextInput = t6;
    let t7;
    if ($[16] !== showError || $[17] !== validateField) {
        t7 = (value_0)=>_async_to_generator(function*() {
                setLink(()=>value_0 || "");
                yield validateField("link", value_0);
                showError("link");
            })();
        $[16] = showError;
        $[17] = validateField;
        $[18] = t7;
    } else t7 = $[18];
    const handleChangeLinkInput = t7;
    let t8;
    if ($[19] !== editor || $[20] !== link || $[21] !== onClose || $[22] !== text) {
        t8 = ()=>{
            editor.update(()=>{
                const selection = $getSelection();
                if ($isRangeSelection(selection)) selection.insertRawText(text);
                editor.dispatchCommand(TOGGLE_LINK_COMMAND, link ? sanitizeUrl(link) : null);
                onClose();
            });
        };
        $[19] = editor;
        $[20] = link;
        $[21] = onClose;
        $[22] = text;
        $[23] = t8;
    } else t8 = $[23];
    const onSubmit = t8;
    const t9 = selectionUrl ? "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u0441\u044B\u043B\u043A\u0438" : "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0441\u044B\u043B\u043A\u0438";
    let t10;
    if ($[24] !== onClose) {
        t10 = /*#__PURE__*/ jsx(Button, {
            size: "large",
            variant: "tertiaryLight",
            type: "button",
            onClick: onClose,
            children: "Отменить"
        });
        $[24] = onClose;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== changed || $[27] !== hasValidationErrors || $[28] !== selectionUrl) {
        t11 = selectionUrl ? /*#__PURE__*/ jsx(Button, {
            disabled: hasValidationErrors || !changed,
            size: "large",
            variant: "primary",
            type: "submit",
            children: "Сохранить"
        }) : /*#__PURE__*/ jsx(Button, {
            disabled: hasValidationErrors,
            size: "large",
            variant: "primary",
            type: "submit",
            children: "Добавить"
        });
        $[26] = changed;
        $[27] = hasValidationErrors;
        $[28] = selectionUrl;
        $[29] = t11;
    } else t11 = $[29];
    let t12;
    if ($[30] !== t10 || $[31] !== t11) {
        t12 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t10,
                t11
            ]
        });
        $[30] = t10;
        $[31] = t11;
        $[32] = t12;
    } else t12 = $[32];
    const t13 = touched.text && !!errors.text;
    const t14 = touched.text ? errors.text : void 0;
    let t15;
    if ($[33] !== handleBlur) {
        t15 = handleBlur("text");
        $[33] = handleBlur;
        $[34] = t15;
    } else t15 = $[34];
    let t16;
    if ($[35] !== handleChangeTextInput || $[36] !== t13 || $[37] !== t14 || $[38] !== t15 || $[39] !== text) {
        t16 = /*#__PURE__*/ jsx(TextInput, {
            label: "\u0422\u0435\u043A\u0441\u0442 \u0441\u0441\u044B\u043B\u043A\u0438",
            required: true,
            placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0442\u0435\u043A\u0441\u0442",
            value: text,
            onChange: handleChangeTextInput,
            name: "text",
            error: t13,
            helperText: t14,
            onBlur: t15
        });
        $[35] = handleChangeTextInput;
        $[36] = t13;
        $[37] = t14;
        $[38] = t15;
        $[39] = text;
        $[40] = t16;
    } else t16 = $[40];
    const t17 = !selectionUrl;
    const t18 = touched.link && !!errors.link;
    const t19 = touched.link ? errors.link : void 0;
    let t20;
    if ($[41] !== handleBlur) {
        t20 = handleBlur("link");
        $[41] = handleBlur;
        $[42] = t20;
    } else t20 = $[42];
    let t21;
    if ($[43] !== handleChangeLinkInput || $[44] !== link || $[45] !== t17 || $[46] !== t18 || $[47] !== t19 || $[48] !== t20) {
        t21 = /*#__PURE__*/ jsx(TextInput, {
            label: "\u0421\u0441\u044B\u043B\u043A\u0430",
            required: t17,
            placeholder: "\u0410\u0434\u0440\u0435\u0441 \u0441\u0441\u044B\u043B\u043A\u0438",
            value: link,
            onChange: handleChangeLinkInput,
            clearable: true,
            name: "link",
            error: t18,
            helperText: t19,
            onBlur: t20
        });
        $[43] = handleChangeLinkInput;
        $[44] = link;
        $[45] = t17;
        $[46] = t18;
        $[47] = t19;
        $[48] = t20;
        $[49] = t21;
    } else t21 = $[49];
    let t22;
    if ($[50] !== onClose || $[51] !== t12 || $[52] !== t16 || $[53] !== t21 || $[54] !== t9) {
        t22 = /*#__PURE__*/ jsxs(DialogContent, {
            title: t9,
            onClose: onClose,
            actions: t12,
            children: [
                t16,
                t21
            ]
        });
        $[50] = onClose;
        $[51] = t12;
        $[52] = t16;
        $[53] = t21;
        $[54] = t9;
        $[55] = t22;
    } else t22 = $[55];
    let t23;
    if ($[56] !== onSubmit || $[57] !== t22) {
        t23 = /*#__PURE__*/ jsx("form", {
            onSubmit: onSubmit,
            children: t22
        });
        $[56] = onSubmit;
        $[57] = t22;
        $[58] = t23;
    } else t23 = $[58];
    let t24;
    if ($[59] !== onClose || $[60] !== open || $[61] !== t23) {
        t24 = /*#__PURE__*/ jsx(Dialog, {
            open: open,
            onClose: onClose,
            children: t23
        });
        $[59] = onClose;
        $[60] = open;
        $[61] = t23;
        $[62] = t24;
    } else t24 = $[62];
    return t24;
};
export { LinkDialog };
